import layoutPlugin from '@zoll/core-layouts/plugin';
import axios from 'axios';
import { inject } from 'inversify';
import { App as VueApp } from 'vue';
import {
  createStore, ModuleTree, Store, StoreOptions,
} from 'vuex';

import { ZOLL_ONLINE } from '@/constants';
import { container } from '@/container';
import { service } from '@/decorators/service';
import { Connection } from '@/services/Connection';
import { Environment } from '@/services/Environment';
import { Logger } from '@/services/Logger';
import { RootState } from '@/store/types';
import { ProxyClass } from '@/utils/ProxyClass';

const resolveVuexPlugins = () => {
  try {
    const logger = container.get(Logger) as unknown as { utilities?: { vuexPlugin?: unknown } } | undefined;
    const plugin = logger?.utilities?.vuexPlugin;
    return plugin ? [plugin] : [];
  }
  catch {
    return [];
  }
};

const options = <StoreOptions<RootState>> {
  modules: <ModuleTree<RootState>> {},
  strict: !import.meta.env.PROD,
  plugins: resolveVuexPlugins(),
};

@service(VuexStore)
export class VuexStore extends ProxyClass(createStore<RootState>(options), 'Vuex') implements Store<RootState> {
  @inject(Environment) protected environment: Environment;
  @inject(Connection) connection: Connection;

  // Methods.
  install(app: VueApp) {
    this.$target.install(app);

    app.use(layoutPlugin, {
      axios,
      /**
       * NOTE: this property is owned by @zoll/core-layouts and expects this casing.
       * @todo @zoll/core-layouts - Fix this.
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      baseURL: `${this.environment.zoBaseUrl}/api`,
      productKey: this.connection.isPortal ? ZOLL_ONLINE.PORTAL_PRODUCT_KEY : ZOLL_ONLINE.DISPATCH_PRODUCT_KEY,
      store: this,
    });

    this.commit('INIT');

    if (this.connection.isPortal) {
      this.subscribe((mutation) => {
        /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, prefer-destructuring */
        const { layouts } = this.state as any;
        if (
          mutation.type === 'SET_LAYOUT' && layouts?.layout?.header && layouts.layout.header.logoutUrl !== ZOLL_ONLINE.PORTAL_LOGOUT_PATH
        ) {
          this.commit('SET_LAYOUT', {
            ...layouts.layout,
            header: { ...layouts.layout.header, logoutUrl: ZOLL_ONLINE.PORTAL_LOGOUT_PATH },
          });
        }
      });
    }
  }
}
